<!-- @format -->

<ng-container *transloco="let t">
  <fudis-grid [columns]="{ sm: 1, md: 'inputLg inputLg' }" [rowGap]="'lg'" [columnGap]="'xxl'">
    <fudis-text-input [control]="form.controls.secondaryEmail" [label]="t('PROFILE.EMAIL')" [autocomplete]="'email'" />
    <fudis-text-input
      [control]="form.controls.phoneNumber"
      [label]="t('PROFILE.PHONE_NUMBER')"
      [autocomplete]="'tel'"
      [helpText]="t('OPEN_UNIVERSITY.STUDIES_ACTIVATE_WIZARD.SUOMI_FI.PHONE_GUIDANCE')" />

    @if (!suomiFiUserBasicDetails.isExistingAndValidStudent) {
      <fudis-select [control]="form.controls.citizenshipUrn" [label]="t('FIELD_NAMES.citizenshipUrns')" [variant]="'autocompleteDropdown'">
        <ng-template fudisSelectOptions>
          @for (option of citizenshipOptions; track option.value) {
            <fudis-select-option [data]="option" />
          }
        </ng-template>
      </fudis-select>
      <fudis-select [control]="form.controls.municipalityUrn" [label]="t('FIELD_NAMES.municipalityUrn')" [variant]="'autocompleteDropdown'">
        <ng-template fudisSelectOptions>
          @for (option of municipalityOptions; track option.value) {
            <fudis-select-option [data]="option" />
          }
        </ng-template>
      </fudis-select>

      <fudis-select [control]="form.controls.motherTongueUrn" [label]="t('FIELD_NAMES.motherTongueUrn')" [variant]="'autocompleteDropdown'">
        <ng-template fudisSelectOptions>
          @for (option of motherTongueOptions; track option.value) {
            <fudis-select-option [data]="option" />
          }
        </ng-template>
      </fudis-select>
      <fudis-select [control]="form.controls.genderUrn" [label]="t('FIELD_NAMES.genderUrn')">
        <ng-template fudisSelectOptions>
          @for (option of genderOptions; track option.value) {
            <fudis-select-option [data]="option" />
          }
        </ng-template>
      </fudis-select>

      <fudis-select [control]="form.controls.preferredLanguageUrn" [label]="t('FIELD_NAMES.preferredLanguageUrn')">
        <ng-template fudisSelectOptions>
          @for (option of preferredLanguageOptions; track option.value) {
            <fudis-select-option [data]="option" />
          }
        </ng-template>
      </fudis-select>
    }
  </fudis-grid>
</ng-container>
